import { SpilDetails } from "./spilDetails.model";
import { IncidentType } from "./incidentType.model";
import { PeopleInvolved } from "./peopleInvolved.model";
import { IncidentCategory } from "./incidentCategory.model";
import { LocationDetails } from "./../../masterscreen/model/admin-master.model";
import { User } from "./../../shared/models/user.model";
import { Location } from "./location.model";
import { Company } from "../../observation/model/company.model";
import { AssignActionPost } from "../../actiontracker/model/actionDetails.model";
import { FileAttachment } from "../../shared/models/file-attachment.model";

export class IncidentRequestPost {
	IncidentRequestId: number = 0;
	RaisedBy: User;
	IncidentDate: Date = new Date();
	LocationId: number;
	SpecificLocation: string;
	IncidentObserveBy: User;
	CommunicationSource: number = 1;
	ActivityTakingAtIncident: string = "";
	InitalFact: string = "";
	IPStatus: string;
	FileUrl: FileAttachment[] = [];
	Pear: string = "People";
	Severity: number = 1;
	RationaleClassification: string = "";
	InitalClassification: string = "";
	CaseOwnerAppointment: User;
	ActionTaken: string = "";
	ImmediateCause: string = "";
	ActorId: number;
	CreatedDate: Date;
	StatusId: number;
	InActive: boolean;
	Location: Location = new Location();
	ShortDescription: string = "";
	DetailDescription: string = "";
	IsHighPotential: boolean;
	SelectedIncidentTypeIds: string[] = [];
	SelectedIncidentTypeNames:any[];
	// SelectedIncidentCategoryIds: number[]=[];
	PeopleIncident: PeopleIncident = new PeopleIncident();
	AssetsIncident: AssetsIncident = new AssetsIncident();
	EnvironmentIncident: EnvironmentIncident = new EnvironmentIncident();
	ReputationIncident: ReputationIncident = new ReputationIncident();
	NPTIncident: NPTIncident = new NPTIncident();
	TimeZone: string;
	ResidualIncidentSeverity: number = 1;
	ResidualIncidentLikelihood: string = "A";
	CompanyId: number;
	UnitId: number;
	InvestigationId: number = 0;
	Status: string;
	ReportedTo: string[];
	IsDraft:boolean=false;
	UnitName:string = "";
	IncidentPEARList: IncidentPearDetails[];
	IncidentPotentialPEARList: PearDetails[];
	Contract:number = 0;
}
export class IncidentPearDetails {
	Pear: String = '';
	Severity: number = 0;
  }
  
export class IncidentRequestGet {
	IncidentRequestId: number;
	DisplayId: string;
	RaisedBy: User;
	IncidentDate: Date = new Date();
	LocationId: Location;
	SpecificLocation: string;
	IncidentObserveBy: User;
	CreatedDate: Date = new Date();
	CommunicationSource: number;
	ActivityTakingAtIncident: string = "";
	InitalFact: string = "";
	IPStatus: string;
	FileUrl: string;
	Pear: string;
	Severity: number;
	RationaleClassification: string = "";
	CaseOwnerAppointment: number;
	ActionTaken: string = "";
	ImmediateCause: string = "";
	ActorId: number;
	StatusId: number;
	SelectedIncidentTypeIds: number[];
	SelectedIncidentCategoryIds: number[];
	InActive: boolean;
	Location: LocationDetails;
	Company: Company;
	NotificationBy: User;
	IncidentCategory: IncidentCategory[];
	IncidentType: IncidentType[];
	CaseOwner: User;
	PeopleInvolvedDetails: PeopleInvolved[];
	SpilDetails: SpilDetails[];
	ClosureRemarks: string = "";
	UploadDocument: string;
	ShortDescription: string = "";
	DetailDescription: string = "";
	InitalClassification: string = "";
	IsHighPotential: boolean;
	PeopleIncident: PeopleIncident = new PeopleIncident();
	AssetsIncident: AssetsIncident = new AssetsIncident();
	EnvironmentIncident: EnvironmentIncident = new EnvironmentIncident();
	ReputationIncident: ReputationIncident = new ReputationIncident();
	NPTIncident: NPTIncident = new NPTIncident();
	Checked: boolean;
	IncidentTypes: string;
	ContractHolder:string;
	ContractNumber:string;
}
export class PeopleIncident {
	PeopleIncidentPear: String = "People";
	PeopleIncidentLikelihood: string = "0";
	PeopleIncidentSeverity: number = 0;
	PeopleSelected: boolean = false;
	PeopleIncidentColor: string = "";
	IncidentPeople: string = "";
}

export class AssetsIncident {
	AssetsIncidentPear: String = "Assets";
	AssetsIncidentLikelihood: string = "0";
	AssetsIncidentSeverity: number = 0;
	AssetsSelected: boolean = false;
	AssetsIncidentColor: string = "";
	IncidentAssets: string = "";
}

export class EnvironmentIncident {
	EnvironmentIncidentPear: String = "Environment";
	EnvironmentIncidentLikelihood: string = "0";
	EnvironmentIncidentSeverity: number = 0;
	EnvironmentSelected: boolean = false;
	EnvironmentIncidentColor: string = "";
	IncidentEnvironment: string = "";
}

export class ReputationIncident {
	ReputationIncidentPear: String = "Reputation";
	ReputationIncidentLikelihood: string = "0";
	ReputationIncidentSeverity: number = 0;
	ReputationSelected: boolean = false;
	ReputationIncidentColor: string = "";
	IncidentReputation: string;
}

export class NPTIncident {
	NPTIncidentPear: String = "NPT";
	NPTIncidentLikelihood: string = "0";
	NPTIncidentSeverity: number = 0;
	NPTSelected: boolean = false;
	NPTIncidentColor: string = "";
	IncidentNPT: string;
}

export class PearDetails {
	IncidentPear: String = "";
	IncidentLikelihood: String = "0";
	IncidentSeverity: number = 0;
}

export class RaiseIncident {
	IncidentRequest: IncidentRequestPost;
	ActionDetails: AssignActionPost[];
}
export class IncidentActionDetails {
	ActionId: number = 0;
	Action: string = "";
	ActionOwnerId: number = 0;
	ActionPartyId: number = 0;
	Priority: number = 2;
	TargetDate: Date = new Date();
	ShowActionErrorMessage: boolean = false;
	ShowActionOwnerErrorMessage: boolean = false;
	ShowActionPartyErrorMessage: boolean = false;
	ShowPriorityErrorMessage: boolean = false;
	ShowTargetErrorMessage: boolean = false;
	ShowActionVerifierErrorMessage: boolean = false;
	ActionOwner: User = new User();
	selectedActionParty: User = new User();
	selectedActionVerifier: User = new User();
	ActionParty: User = new User();
	Status: string = "Open";
	ShowActionbuttons: boolean = false;
	selectedAction: string;
	SelectedAction: boolean;
	UnitId: number;
	Files: FileAttachment[] = [];
	FilesPreview: FileAttachment[] = [];
	ProcessId: number;
}
export class IncidentAction {
	public SourceId: number;
	public RaisedBy: number;
	public incidentActionDetailsRequest: IncidentActionDetails[];
	public ProcessName: string;
}
export class CaseOwnerIncidentAction {
	public caseOwner: IncidentProcess[];
	public IncidentRequestId: number;
	// public ActionId: number;
	public UploadedBy: number;
}
export class CaseOwnerAction {
	Name: string;
	FileUrl: any[] = []; // Document File
	DueDate: Date;
	Enabled: boolean = true;
	SelectedMarkAction: boolean = false;
	CaseOwnerActionId: 0;
}
export class SubmitTorAction {
	Name: string = "Submit TOR";
	FileUrlTOR: any[] = []; // Document File
	DueDate: Date = new Date();
	Enabled: boolean = true;
	SelectedMarkAction: boolean = false;
	CaseOwnerActionId: number = 0;
}
export class SubmitDraftReportAction {
	Name: string = "Submit Draft Report";
	FileUrlDraft: any[] = []; // Document File
	DueDate: Date = new Date();
	Enabled: boolean;
	SelectedMarkAction: boolean = false;
	CaseOwnerActionId: number = 0;
}
export class SubmitInvestigationAction {
	Name: string = "Submit Final Investigation Report";
	FileUrlInvestigation: any[] = []; // Document File
	DueDate: Date = new Date();
	Enabled: boolean;
	SelectedMarkAction: boolean = false;
	CaseOwnerActionId: number = 0;
}
export class SubmitMOM {
	Name: string = "MOM Management Meeting Review";
	FileUrlInvestigation: any[] = []; // Document File
	DueDate: Date = new Date();
	Enabled: boolean;
	SelectedMarkAction: boolean = false;
	CaseOwnerActionId: number = 0;
}
export class IncidentProcess {
	IncidentProcessId: number = 0;
	IncidentProcessName: string = "";
	IncidentProcessDateBuffer: any;
	IncidentDate: Date = new Date();
	FileUrl: FileAttachment[] = []; // Document File
	SelectedMarkAction: boolean = false;
	CaseOwnerActionId: number = 0;
	Files: any[] = [];
	IsActive: boolean = true;
	IsDelete:boolean=false;
	TemplateFiles?: FileAttachment[] = [];
}
